export default __webpack_public_path__ + "static/media/adas.96bef263.svg";